import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicFormComponent } from './dynamic-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FlexModule } from '@angular/flex-layout';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { InputsModule } from '@shared/modules/inputs/inputs.module';
import { NgxCaptchaModule } from 'ngx-captcha';
@NgModule({
  declarations: [DynamicFormComponent],
  exports: [DynamicFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    FlexModule,
    MatSelectModule,
    MatCheckboxModule,
    MatIconModule,
    InputsModule,
    NgxCaptchaModule
  ]
})
export class DynamicFormModule { }
